import React from "react";
import { graphql } from "gatsby";
import { QuoteFragmentFragment } from "../../graphql-types";
import Image from "./Image";
import styles from "../styles/Quote.module.scss";

type Props = { data: QuoteFragmentFragment };

const Quote = ({ data }: Props) => {
  const { avatar, quote, name, position, organisation } = data.elements;
  const role = [position?.value, organisation?.value]
    .filter(Boolean)
    .join(" at ");

  return (
    <div className={styles["Quote"]}>
      <figure>
        <Image data={avatar.value[0]} />
        <blockquote>
          <p>{quote.value}</p>
          <figcaption>
            <cite>
              {name.value}
              {role && <span>{role}</span>}
            </cite>
          </figcaption>
        </blockquote>
      </figure>
    </div>
  );
};

export default Quote;

export const query = graphql`
  fragment QuoteFragment on kontent_item_quote {
    elements {
      avatar {
        value {
          ...ImageFragment
        }
      }
      quote {
        value
      }
      name {
        value
      }
      position {
        value
      }
      organisation {
        value
      }
    }
  }
`;
